export const DESTINATIONS = {
  jilin: {
    chapter: 'china',
    nameCn: '吉林',
    nameEn: 'JILIN',
    titleCn: '雾凇松韵',
    colorBg: '#F6F4F1',
    products: ["3100139154", "3100190436", "3100191509", "3200039326", "3200069707"],
    introCaptions: [
      { zh: '雾凇晨曦', en: 'RIME AT DAWN' },
      { zh: '长白山天池', en: 'HEAVENLY LAKE ON CHANGBAI MOUNTAIN' },
      { zh: '查干湖冬捕', en: 'WINTER FISHING AT CHAGAN LAKE' }
    ],
    introColor: { zh: '#1A4B82', en: '#1A4B82' },
    picList: [
      'https://pro-static.ourtour.com/obs/assets/new-journey-h5/jilin1-26840150.jpg',
      'https://pro-static.ourtour.com/obs/assets/new-journey-h5/jilin2-002fdea6.jpg',
      'https://pro-static.ourtour.com/obs/assets/new-journey-h5/jilin3-1466bc46.jpg'
    ],
    introList: [
      'https://pro-static.ourtour.com/obs/assets/default/hongkong-Rime at Dawn-03ec0667.jpg',
      'https://pro-static.ourtour.com/obs/assets/default/hongkong-Heavenly Lake on Changbai Mountain-03477ae5.jpg',
      'https://pro-static.ourtour.com/obs/assets/default/hongkong-Winter Fishing at Chagan Lake-c3639603.jpg'
    ],
    collected: 'https://pro-static.ourtour.com/obs/assets/new-journey-h5/jilin-collected-4365a2e8.jpg',
    unCollected: 'https://pro-static.ourtour.com/obs/assets/new-journey-h5/jilin-unCollect-0e239e34.jpg'
  },

  shanxi: {
    chapter: 'china',
    nameCn: '陕西',
    nameEn: 'shanxi',
    titleCn: '长安遗韵',
    colorBg: '#EEDFCA',
    products: ["3100056901", "3100182473", "3100108179", "3200068638", "3200068334"],
    introCaptions: [
      { zh: '大雁塔', en: 'BIG WILD GOOSE PAGODA' },
      { zh: '华山', en: 'HUASHAN MOUNTAIN' },
      { zh: '秦始皇兵马俑', en: 'THE TERRACOTTA WARRIORS AND HORSES' }
    ],
    introColor: { zh: '#231B17', en: '#504E4B' },
    picList: [
      'https://pro-static.ourtour.com/obs/assets/new-journey-h5/shanxi1-b9a96d46.jpg',
      'https://pro-static.ourtour.com/obs/assets/new-journey-h5/shanxi2-caf5de41.jpg',
      'https://pro-static.ourtour.com/obs/assets/new-journey-h5/shanxi3-fd22a726.jpg'
    ],
    introList: [
      'https://pro-static.ourtour.com/obs/assets/default/hongkong-BIG WILD GOOSE PAGODA-f2e7920a.png',
      'https://pro-static.ourtour.com/obs/assets/default/hongkong-Huashan Mountain-764bc160.jpg',
      'https://pro-static.ourtour.com/obs/assets/default/hongkong-the Terracotta Warriors and Horses-64c52342.jpg'
    ],
    collected: 'https://pro-static.ourtour.com/obs/assets/new-journey-h5/shanxi-collected-df7757e7.jpg',
    unCollected: 'https://pro-static.ourtour.com/obs/assets/new-journey-h5/shanxi-unCollected-14f14da8.jpg'
  },

  anhui: {
    chapter: 'china',
    nameCn: '安徽',
    nameEn: 'ANHUI',
    titleCn: '徽风皖韵',
    colorBg: '#F1EFE8',
    products: ["3100154587", "3100129702", "3100129703", "3200068624", "3200071974"],
    introCaptions: [
      { zh: '黄山云海', en: 'SEA OF CLOUDS AT HUANGSHAN MOUNTAIN' },
      { zh: '宏村月沼', en: 'HONGCUN VILLAGE' },
      { zh: '徽派马头墙', en: 'HUIZHOU-STYLE HORSE-HEAD WALLS' }
    ],
    introColor: { zh: '#231B17', en: '#504E4B' },
    picList: [
      'https://pro-static.ourtour.com/obs/assets/new-journey-h5/anhui1-08ee8bb3.jpg',
      'https://pro-static.ourtour.com/obs/assets/new-journey-h5/anhui2-b5fef08c.jpg',
      'https://pro-static.ourtour.com/obs/assets/new-journey-h5/anhui3-2fb60ac2.jpg'
    ],
    introList: [
      'https://pro-static.ourtour.com/obs/assets/default/hongkong-sea-of-clouds-dafc8b35.jpg',
      'https://pro-static.ourtour.com/obs/assets/default/hongkong-Hongcun Village-7cee7ba2.jpg',
      'https://pro-static.ourtour.com/obs/assets/default/hongkong-Huizhou-style Horse-head Walls-55cae8e2.jpg'
    ],
    collected: 'https://pro-static.ourtour.com/obs/assets/new-journey-h5/anhui-collected-9fcffda7.jpg',
    unCollected: 'https://pro-static.ourtour.com/obs/assets/new-journey-h5/anhui-unCollected-30598791.jpg'
  },

  jiangsu: {
    chapter: 'china',
    nameCn: '江苏',
    nameEn: 'JIANGSU',
    titleCn: '江南诗意',
    colorBg: '#E7E7DD',
    products: ["3100113041", "3100116977", "3100105967", "3100183186", "3200071309"],
    introCaptions: [
      { zh: '拙政园', en: "HUMBLE ADMINISTRATOR'S GARDEN" },
      { zh: '周庄古镇', en: 'ZHOUZHUANG ANCIENT TOWN' },
      { zh: '秦淮河', en: 'QINHUAI RIVER' }
    ],
    introColor: { zh: '#353535', en: '#3F4E33A1' },
    picList: [
      'https://pro-static.ourtour.com/obs/assets/new-journey-h5/jiangsu1-31b33c95.jpg',
      'https://pro-static.ourtour.com/obs/assets/new-journey-h5/jiangsu2-60767ed2.jpg',
      'https://pro-static.ourtour.com/obs/assets/new-journey-h5/jiangsu3-3b684ac3.jpg'
    ],
    introList: [
      "https://pro-static.ourtour.com/obs/assets/default/hongkong-Humble Administrator's Garden-764a48ae.jpg",
      'https://pro-static.ourtour.com/obs/assets/default/hongkong-Zhouzhuang Ancient Town-b8560074.jpg',
      'https://pro-static.ourtour.com/obs/assets/default/hongkong-Qinhuai River-60198e60.jpg'
    ],
    collected: 'https://pro-static.ourtour.com/obs/assets/new-journey-h5/jiangsu-collected-20f963cf.jpg',
    unCollected: 'https://pro-static.ourtour.com/obs/assets/new-journey-h5/jiangsu-unCollect-48fc9e6f.jpg'
  },

  hainan: {
    chapter: 'china',
    nameCn: '海南',
    nameEn: 'HAINAN',
    titleCn: '椰岛阳光',
    colorBg: '#FAF5E2',
    products: ["3100150352", "3100150355", "3100150353", "3200064952", "3200067069"],
    introCaptions: [
      { zh: '亚龙湾', en: 'YALONG BAY' },
      { zh: '分界洲', en: 'FENJIEZHOU ISLAND' },
      { zh: '海口骑楼', en: 'HAIKOU ARCADE BUILDING' }
    ],
    introColor: { zh: '#231B17', en: '#504E4B' },
    picList: [
      'https://pro-static.ourtour.com/obs/assets/new-journey-h5/hainan1-a3795c3e.jpg',
      'https://pro-static.ourtour.com/obs/assets/new-journey-h5/hainan2-c5689f32.jpg',
      'https://pro-static.ourtour.com/obs/assets/new-journey-h5/hainan3-1cd431eb.jpg'
    ],
    introList: [
      'https://pro-static.ourtour.com/obs/assets/default/hongkong-Yalong Bay-bf9fc9d3.jpg',
      'https://pro-static.ourtour.com/obs/assets/default/hongkong-Fenjiezhou Island-57616abc.png',
      'https://pro-static.ourtour.com/obs/assets/default/hongkong-Haikou Arcade Building-ce3d8a58.jpg'
    ],
    collected: 'https://pro-static.ourtour.com/obs/assets/new-journey-h5/hainan-collected-79f13747.jpg',
    unCollected: 'https://pro-static.ourtour.com/obs/assets/new-journey-h5/hainan-unCollect-aa4b77d1.jpg'
  },

  xinjiang: {
    chapter: 'china',
    nameCn: '新疆',
    nameEn: 'XINJIANG',
    titleCn: '西域天境',
    colorBg: '#FAF0E6',
    products: ["3100171536", "3100170718", "3200059908", "3200059954", "3200060018"],
    introCaptions: [
      { zh: '独库公路', en: 'DUSHANZI-KUQA HIGHWAY' },
      { zh: '天山天池', en: 'HEAVENLY LAKE OF TIANSHAN' },
      { zh: '喀纳斯晨雾', en: 'KANAS LAKE' }
    ],
    introColor: { zh: '#231B17', en: '#504E4B' },
    picList: [
      'https://pro-static.ourtour.com/obs/assets/new-journey-h5/xinjiang1-0441d6d8.jpg',
      'https://pro-static.ourtour.com/obs/assets/new-journey-h5/xinjiang2-fcf13879.jpg',
      'https://pro-static.ourtour.com/obs/assets/new-journey-h5/xinjiang3-607227d2.jpg'
    ],
    introList: [
      'https://pro-static.ourtour.com/obs/assets/default/hongkong-Dushanzi-Kuqa Highway-7818c688.jpg',
      'https://pro-static.ourtour.com/obs/assets/default/hongkong-Heavenly Lake of Tianshan-757c8486.jpg',
      'https://pro-static.ourtour.com/obs/assets/default/hongkong-Kanas Lake-5a552e17.jpg'
    ],
    collected: 'https://pro-static.ourtour.com/obs/assets/new-journey-h5/xinjiang-collected-7c93e01f.jpg',
    unCollected: 'https://pro-static.ourtour.com/obs/assets/new-journey-h5/xinjiang-unCollect-74ff00e8.jpg'
  },

  turkey: {
    chapter: 'world',
    nameCn: '土耳其',
    nameEn: 'TÜRKİYE',
    titleCn: '双海之畔',
    colorBg: '#EFE5EE',
    products: ["3100022361", "3100128982", "3100162974", "3100189326"],
    introCaptions: [
      { zh: '热气球', en: 'HOT-AIR BALLOON' },
      { zh: '棉花堡', en: 'PAMUKKALE' },
      { zh: '苏莱曼尼耶清真寺', en: 'SÜLEYMANIYE MOSQUE' }
    ],
    introColor: { zh: '#36273A', en: '#59365C' },
    picList: [
      'https://pro-static.ourtour.com/obs/assets/new-journey-h5/turkey1-2ec66ae3.jpg',
      'https://pro-static.ourtour.com/obs/assets/new-journey-h5/turkey2-f0787c89.jpg',
      'https://pro-static.ourtour.com/obs/assets/new-journey-h5/turkey3-df3cec87.jpg'
    ],
    introList: [
      'https://pro-static.ourtour.com/obs/assets/default/hongkong-Hot-air Balloon-4ed50c7e.jpg',
      'https://pro-static.ourtour.com/obs/assets/default/hongkong-Pamukkale-4f06e447.jpg',
      'https://pro-static.ourtour.com/obs/assets/default/hongkong-Süleymaniye Mosque-192bbe5d.jpg'
    ],
    collected: 'https://pro-static.ourtour.com/obs/assets/new-journey-h5/turkey-collected-69b299df.jpg',
    unCollected: 'https://pro-static.ourtour.com/obs/assets/new-journey-h5/turkey-unCollect-847d5ccb.jpg'
  },

  saudi: {
    chapter: 'world',
    nameCn: '沙特',
    nameEn: 'SAUDI ARABIA',
    titleCn: '沙漠玫瑰',
    colorBg: '#F9EAD2',
    products: ["3200072643", "3100159951", "3100159792", "3100045425", "3100040334"],
    introCaptions: [
      { zh: '埃尔奥拉', en: 'ALULA REGION' },
      { zh: '世界之崖', en: 'EDGE OF THE WORLD' },
      { zh: '马拉亚音乐厅', en: 'MARAYA CONCERT HALL' }
    ],
    introColor: { zh: '#25150C', en: '#948973' },
    picList: [
      'https://pro-static.ourtour.com/obs/assets/new-journey-h5/saudi1-ac1c63f1.jpg',
      'https://pro-static.ourtour.com/obs/assets/new-journey-h5/saudi2-ef0e0722.jpg',
      'https://pro-static.ourtour.com/obs/assets/new-journey-h5/saudi3-533c429d.jpg'
    ],
    introList: [
      'https://pro-static.ourtour.com/obs/assets/default/hongkong-AlUla Region-013278ba.jpg',
      'https://pro-static.ourtour.com/obs/assets/default/hongkong-Edge of the World-967a66fd.jpg',
      'https://pro-static.ourtour.com/obs/assets/default/hongkong-Maraya Concert Hall-e0eec8a5.jpg'
    ],
    collected: 'https://pro-static.ourtour.com/obs/assets/new-journey-h5/saudi-collected-2277a6ec.jpg',
    unCollected: 'https://pro-static.ourtour.com/obs/assets/new-journey-h5/saudi-unCollect-13b05c5a.jpg'
  },

  france: {
    chapter: 'world',
    nameCn: '法国',
    nameEn: 'FRANCE',
    titleCn: '浪漫之都',
    colorBg: '#122D64',
    products: ["3100194964", "3100039167", "3100106102", "3100033534", "3100119644"],
    introCaptions: [
      { zh: '埃菲尔铁塔', en: 'EIFFEL TOWER' },
      { zh: '罗浮宫', en: 'LOUVRE MUSEUM' },
      { zh: '普罗旺斯', en: 'PROVENCE' }
    ],
    introColor: { zh: '#F7C881', en: '#F7C881' },
    picList: [
      'https://pro-static.ourtour.com/obs/assets/new-journey-h5/france1-2e111c3c.jpg',
      'https://pro-static.ourtour.com/obs/assets/new-journey-h5/france2-ed2b0dad.jpg',
      'https://pro-static.ourtour.com/obs/assets/new-journey-h5/france3-2d707809.jpg'
    ],
    introList: [
      'https://pro-static.ourtour.com/obs/assets/default/hongkong-Eiffel -Tower-8367cce4.jpg',
      'https://pro-static.ourtour.com/obs/assets/default/hongkong-Louvre- Museum-b7743841.jpg',
      'https://pro-static.ourtour.com/obs/assets/default/hongkong-Provence-e89b5fab.jpg'
    ],
    collected: 'https://pro-static.ourtour.com/obs/assets/new-journey-h5/france-collected-466657f5.jpg',
    unCollected: 'https://pro-static.ourtour.com/obs/assets/new-journey-h5/france-unCollect-013ffd1c.jpg'
  },

  spain: {
    chapter: 'world',
    nameCn: '西班牙',
    nameEn: 'ESPAÑA',
    titleCn: '热情之地',
    colorBg: '#FDEFDE',
    products: ["3100074368", "3100039978", "3100020204", "3100044607", "3100155954", "3100186120"],
    introCaptions: [
      { zh: '阿尔罕布拉宫', en: 'ALHAMBRA PALACE' },
      { zh: '巴特罗之家', en: 'CASA BATLLO' },
      { zh: '圣家堂', en: 'SAGRADA FAMILIA' }
    ],
    introColor: { zh: '#231B17', en: '#504E4B' },
    picList: [
      'https://pro-static.ourtour.com/obs/assets/new-journey-h5/spain1-f4534e4c.jpg',
      'https://pro-static.ourtour.com/obs/assets/new-journey-h5/spain2-a7e444ee.jpg',
      'https://pro-static.ourtour.com/obs/assets/new-journey-h5/spain3-9550d4a7.jpg'
    ],
    introList: [
      'https://pro-static.ourtour.com/obs/assets/default/hongkong-Alhambra Palace-d02ac1f5.jpg',
      'https://pro-static.ourtour.com/obs/assets/new-journey-h5/hongkong-Casa Batlló-6621be64.jpg',
      'https://pro-static.ourtour.com/obs/assets/new-journey-h5/hongkong-Sagrada Família-b9a2a740.jpg'
    ],
    collected: 'https://pro-static.ourtour.com/obs/assets/new-journey-h5/spain-collected-b6f4cbcc.jpg',
    unCollected: 'https://pro-static.ourtour.com/obs/assets/new-journey-h5/spain-unCollect-60a09670.jpg'
  }
}
